import { PrettyCurrency, Typography } from 'components';
import { useTranslations } from 'next-intl';
import { useBalance } from 'providers/InvoicesProviders/useBalance';
import { cn } from 'utils/cn';

export default function CurrentBalance() {
  const t = useTranslations();
  const { data, isLoading } = useBalance();

  if (isLoading) return null;

  const amount = Number(data?.invoiceBalance);

  return (
    <div className="dont_print mb-7 rounded-md bg-white p-6 py-4 shadow-custom">
      <div>
        <Typography variant="regular3" className="text-tertiary-200">
          {amount > 0 && <>{t('billing.payments.type.refund_due')}</>}
          {amount < 0 && <>{t('billing.payments.type.amount_payable')}</>}
          {amount === 0 && <>{t('billing.payments.type.zero_balance')}</>}
        </Typography>
      </div>
      <div className="!pt-[5px]">
        <Typography variant="bold6xl" className={cn('!mb-0 text-tertiary-100')}>
          <PrettyCurrency currency={data?.currency} amount={Math.abs(amount)} />
        </Typography>
      </div>
    </div>
  );
}
